/**
 * Results feature API — maps to backend Scoring context endpoints.
 *
 * Prefix: /results  (registered at /api/results in Flask)
 */
import { httpClient } from '@/lib/http-client'

export const resultsApi = {
    // ── Scoring / Results ─────────────────────────────────────────────────
    get: (id: string) =>
        httpClient.get(`/results/assessments/${id}/results`),

    recalculate: (id: string) =>
        httpClient.post(`/results/assessments/${id}/recalculate`),

    // ── Report Data (for frontend report page) ────────────────────────────
    getReportData: (id: string, options?: { include_recommendations?: boolean; include_answers?: boolean }) =>
        httpClient.get(`/reports/assessments/${id}/data`, {
            params: options,
        }),
}
